export const redirectToAllSales: () => void = () => {
  const viewAllSalesUrl = `${window.location.origin}/current-sales`;
  window.location.href = viewAllSalesUrl;
};
